import { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import { Pencil } from "lucide-react";
import { Card, CardContent } from "../../../../components/ui/Card";
import { Badge } from "../../../../components/ui/Badge";
import backendApi from "../../../utils/BackendApi.js";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useCallback, useMemo } from "react";


import { Container } from '@mui/material';

export default function ConsegneCalendar() {
  const [allOrders, setAllOrders] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  // PC1 = dataPrevCons1
  // PC2 = dataPrevCons2
  // BOTH = entrambe
  const [deliveryFilter, setDeliveryFilter] = useState("PC2"); // default
  const [customerFilter, setCustomerFilter] = useState("");
  const [lotFilter, setLotFilter] = useState("");
  const [activeMonth, setActiveMonth] = useState(new Date());
  const [editOrder, setEditOrder] = useState(null);
  const [editDate, setEditDate] = useState(null);
  const [updatingDeliveryId, setUpdatingDeliveryId] = useState(null);
  const [vettori, setVettori] = useState([]);
  const [loadingVettori, setLoadingVettori] = useState(false);
  const [editVettoreOrder, setEditVettoreOrder] = useState(null);
  const [selectedVettoreCode, setSelectedVettoreCode] = useState("");
  const [updatingVettoreId, setUpdatingVettoreId] = useState(null);

  {/*const isoToLocalDate = (iso) => iso ? iso.split("T")[0] : null;*/}

  const isoToLocalDate = (iso) => {
    if (!iso) return null;

    // Se è già un oggetto Date
    const d = iso instanceof Date ? iso : new Date(iso);

    // Se la data è invalida
    if (isNaN(d.getTime())) return null;

    // Formato YYYY-MM-DD
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const getEffectivePC2Date = (order) => {
    if (order?.listeEvasione?.length > 0) {
      // prendo la prima data di inizio trasporto valida
      const withTransport = order.listeEvasione.find(l => l.inizioTrasporto);
      if (withTransport?.inizioTrasporto) {
        return isoToLocalDate(withTransport.inizioTrasporto);
      }
    }

    return isoToLocalDate(order.dataPrevCons2);
  };

//  const getEffectivePC2Date = (order) => {
//    const transportDate = order?.listeEvasione?.find(
//      (l) => l?.inizioTrasporto
//    )?.inizioTrasporto;
//
//    return isoToLocalDate(
//      transportDate || order?.dataPrevCons2
//    );
//  };

  const formatTrasporto = (value) => {

    if (!value) return "—";

    const dt = new Date(value);

    const hasTime =
      dt.getHours() !== 0 ||
      dt.getMinutes() !== 0 ||
      dt.getSeconds() !== 0;

    const formattedDate = dt.toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    let result;

    if (hasTime) {
      result = dt.toLocaleString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } else {
         result = `${formattedDate} (orario non indicato)`;
       }

    return result;
  };



  const getMonthRange = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();

    // Primo e ultimo giorno del mese
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    // Trova il lunedì della prima settimana del mese
    const firstWeekStart = new Date(firstDay);
    const dayOfWeekStart = firstWeekStart.getDay() || 7; // Domenica = 7
    firstWeekStart.setDate(firstWeekStart.getDate() - (dayOfWeekStart - 1));

    // Trova la domenica dell’ultima settimana del mese
    const lastWeekEnd = new Date(lastDay);
    const dayOfWeekEnd = lastWeekEnd.getDay() || 7;
    lastWeekEnd.setDate(lastWeekEnd.getDate() + (7 - dayOfWeekEnd));

    const format = (d) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

    return { from: format(firstWeekStart), to: format(lastWeekEnd) };
  };


  const getMonthWeeklyTotals = (events, referenceDate) => {
    const year = referenceDate.getFullYear();
    const month = referenceDate.getMonth();

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    const weeks = [];

    // Trova il lunedì della prima settimana del mese (anche se è a settembre)
    const firstWeekStart = new Date(firstDayOfMonth);
    firstWeekStart.setDate(firstDayOfMonth.getDate() - ((firstDayOfMonth.getDay() + 6) % 7));

    let start = new Date(firstWeekStart);

    while (start <= lastDayOfMonth) {
      const end = new Date(start);
      end.setDate(start.getDate() + 6); // Domenica

      // Somma tutte le consegne della settimana, anche fuori dal mese
      let total = 0;
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const key = formatDate(d);
        if (events[key]) total += events[key];
      }

      weeks.push({
        start: new Date(start),
        end: new Date(end),
        total
      });

      start.setDate(start.getDate() + 7);
    }

    return weeks;
  };

  const fetchConsegne = async (from, to) => {
    setLoading(true);
    try {
      const consegneRes = await backendApi.get(`/api/consegne`, { params: { from, to } });
      const data = consegneRes.data || [];
      setAllOrders(data);

      backendApi.post(`/api/production/assignments/by-document-ids`, getProductionLookupPayload(data))
        .then((productionRes) => {
          const productionByIdDocumento = new Map(
            (productionRes.data || [])
              .filter((order) => order?.idDocumento)
              .map((order) => [String(order.idDocumento), order])
          );
          setAllOrders((currentOrders) =>
            currentOrders.map((order) => {
              const productionOrder = productionByIdDocumento.get(String(order.idDocumento));
              if (!productionOrder) return order;

              return {
                ...order,
                lotto: productionOrder.lotto,
                statoProduzione: getProductionStatusValue(productionOrder),
                operaiProduzione: productionOrder.operai,
                idProduzione: productionOrder.id || productionOrder.idProduzione,
                sortOrder: productionOrder.sortOrder,
              };
            })
          );
        })
        .catch((err) => {
          console.warn("Info produzione non disponibili per il calendario:", err);
        });
    } catch (err) {
      console.error("Errore fetch consegne:", err);
      toast.error("⚠️ Impossibile contattare il server.", {
        style: { background: "#fff8e1", color: "#8a6d3b", borderRadius: "10px" },
        icon: "📦",
      });
      setAllOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshConsegneForDate = async (date) => {
    const { from, to } = getMonthRange(date);
    await fetchConsegne(from, to);
  };

  function getProductionLookupPayload(orders) {
    const seen = new Set();

    return (orders || [])
      .map((order) => order?.idDocumento)
      .filter((idDocumento) => Number.isInteger(idDocumento) && idDocumento > 0)
      .filter((order) => {
        if (seen.has(order)) return false;
        seen.add(order);
        return true;
      });
  }

//    useEffect(() => {
//      const today = new Date();
//      const { from, to } = getMonthRange(today);
//      fetchConsegne(from, to);
//    }, []);

  const normalizeFilterText = useCallback((value) =>
    String(value || "")
      .trim()
      .toLowerCase(), []);

  const getCustomerFilterLabel = useCallback((order) => {
    const parts = [order?.idCliente, order?.ragioneSociale].filter(Boolean);
    return parts.length > 0 ? parts.join(" - ") : "Cliente non indicato";
  }, []);

  const getOrderSearchCustomer = useCallback((order) =>
    [
      order?.idCliente,
      order?.ragioneSociale,
      getCustomerFilterLabel(order),
    ]
      .filter(Boolean)
      .join(" "), [getCustomerFilterLabel]);

  const matchesCustomerFilter = useCallback((order, filter) => {
    const normalized = normalizeFilterText(filter);
    if (!normalized) return true;
    return normalizeFilterText(getOrderSearchCustomer(order)).includes(normalized);
  }, [getOrderSearchCustomer, normalizeFilterText]);

  const matchesLotFilter = useCallback((order, filter) => {
    const normalized = normalizeFilterText(filter);
    if (!normalized) return true;
    return normalizeFilterText(order?.lotto).includes(normalized);
  }, [normalizeFilterText]);

  const visibleOrders = useMemo(
    () =>
      allOrders.filter((order) =>
        matchesCustomerFilter(order, customerFilter) &&
        matchesLotFilter(order, lotFilter)
      ),
    [allOrders, customerFilter, lotFilter, matchesCustomerFilter, matchesLotFilter]
  );

  const customerOptions = useMemo(() => {
    const options = new Map();

    allOrders.forEach((order) => {
      const label = getCustomerFilterLabel(order);
      if (label !== "Cliente non indicato") {
        options.set(label, label);
      }
    });

    return Array.from(options.values()).sort((a, b) => a.localeCompare(b));
  }, [allOrders, getCustomerFilterLabel]);

  const lotOptions = useMemo(() => {
    const options = new Set();

    allOrders.forEach((order) => {
      if (order?.lotto) options.add(String(order.lotto));
    });

    return Array.from(options).sort((a, b) => b.localeCompare(a));
  }, [allOrders]);

  const hasDataFilters = Boolean(customerFilter.trim() || lotFilter.trim());

  const clearDataFilters = () => {
    setCustomerFilter("");
    setLotFilter("");
  };

useEffect(() => {
  if (!selectedDate) return;

  const filtered = filterOrdersByDateAndType(
    visibleOrders,
    selectedDate,
    deliveryFilter
  );

  setSelectedOrders(filtered);
}, [deliveryFilter, selectedDate, visibleOrders]);

  useEffect(() => {
    const { from, to } = getMonthRange(activeMonth);
    fetchConsegne(from, to);
  }, [activeMonth]);

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      const dayCount = filteredEvents[dateStr] || 0;
      if (dayCount > 0) {
        const dayColor = dayCount < 5 ? "#60a5fa" : dayCount < 10 ? "#fbbf24" : "#ef4444";
        return <Badge color={dayColor}>{dayCount}</Badge>;
      }
    }
    return null;
  };

//  const handleDayClick = (value) => {
//    const dayStr = `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
//    setSelectedDate(dayStr);
//
//    const ordersForDay = allOrders.filter((o) => {
//      const d1 = isoToLocalDate(o.dataPrevCons1);
//      const d2 = isoToLocalDate(o.dataPrevCons2);
//      return dayStr === d1 || dayStr === d2;
//    });
//    setSelectedOrders(ordersForDay);
//  };
    const handleDayClick = (value) => {
      const dayStr = formatDate(value);
      setSelectedDate(dayStr);

      const filtered = filterOrdersByDateAndType(
        visibleOrders,
        dayStr,
        deliveryFilter
      );

      setSelectedOrders(filtered);
    };

  const getWeekRange = (date) => {
    const start = new Date(date);
    start.setDate(date.getDate() - date.getDay() + 1); // lunedì
    const end = new Date(start);
    end.setDate(start.getDate() + 6); // domenica
    return { start, end };
  };

  const formatDate = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

  const getWeeklyTotal = (events, date) => {
    const { start, end } = getWeekRange(date);
    let total = 0;
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const key = formatDate(d);
      if (events[key]) total += events[key];
    }
    return total;
  };

  const getWeekNumber = (date) => {
    const temp = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = temp.getUTCDay() || 7; // domenica = 7
    temp.setUTCDate(temp.getUTCDate() + 4 - dayNum); // sposta al giovedì della settimana
    const yearStart = new Date(Date.UTC(temp.getUTCFullYear(), 0, 1));
    const weekNum = Math.ceil(((temp - yearStart) / 86400000 + 1) / 7);
    return weekNum;
  };

  const getVettoreExport = (order) => {
    // 1️⃣ vettore dalla lista di evasione
    if (order?.listeEvasione?.length > 0) {
        const vettori = order.listeEvasione
          .map(l => l.vettore)
          .filter(Boolean);

        if (vettori.length > 0) {
          return [...new Set(vettori)].join(", ");
        }

        return "-";
      }

    // 2️⃣ vettore sull'ordine
    if (order.descrizioneVettore) {
      return `${order.codiceVettore || ""} - ${order.descrizioneVettore}`;
    }

    // 3️⃣ fallback cliente
    return "-";
  };

    // Esporta in Excel
    const handleExportExcel = () => {
      if (!selectedOrders || selectedOrders.length === 0) {
        toast.warning("⚠️ Nessuna consegna da esportare");
        return;
      }

      // Converte gli ordini in foglio Excel
      const worksheet = XLSX.utils.json_to_sheet(
        selectedOrders.map((o) => ({
          "Rif. Ordine Cliente": o.rifOrdCli,
          "Tipo Documento": o.tipoDoc,
          "Numero Documento": o.numDoc,
          "Data Documento": o.dataDoc ? isoToLocalDate(o.dataDoc) : "-",
          "Cliente": o.ragioneSociale
            ? `${o.idCliente || ""} - ${o.ragioneSociale}`
            : "-",
          "Condizione Pagamento": o.conPagamento || "-",
          "Telefono Cliente": o.telefonoCliente || "-",
          "Email Cliente": o.emailCliente || "-",
          "Indirizzo": o.indirizzoCliente || "-",
          "Cap": o.capCliente || "-",
          "Località Cliente": o.localitaCliente || "-",
          "Provincia Cliente": o.provinciaCliente || "-",
          "Cliente Bloccato": o.blocco?.trim()?.toUpperCase() === "S" ? "SI" : "NO",
          "Destinazione": o.idDestinazione
            ? `${o.idDestinazione} - ${o.indirizzoDestinazione} - ${o.localitaDestinazione} (${o.provinciaDestinazione})`
            : "—",
          "Consegna 1": o.dataPrevCons1 ? isoToLocalDate(o.dataPrevCons1) : "-",
          "Consegna 2": getEffectivePC2Date(o) || "-",
          "Vettore": getVettoreExport(o),
          "Imponibile": o.importoDoc != null
            ? Number(o.importoDoc).toFixed(2)
            : "0.00",
          "Totale Ivato": o.importoDocIva != null
            ? Number(o.importoDocIva).toFixed(2)
            : "0.00",
          "Data Conferma Ordine": o.selData ? isoToLocalDate(o.selData) : "-",
          "Data Invio in Produzione": o.dataInvio ? isoToLocalDate(o.dataInvio) : "-",
          "Annotazioni": o.noteDoc || "-",
          "Lista evasione": getListeEvasioneLabel(o),
          "Lotto": o.lotto || "-",
          "Stato Produzione": o.statoProduzione || "-",
          "Operai Produzione": getProductionWorkersLabel(o)
        }))
      );

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Consegne");

      // 🔹 Secondo foglio — riepilogo settimanale
        const weeklyTotals = getMonthWeeklyTotals(filteredEvents, new Date(selectedDate)).map((week, idx) => ({
          "Settimana": `Week ${getWeekNumber(week.start)}`,
          "Dal": formatDate(week.start),
          "Al": formatDate(week.end),
          "Totale consegne": week.total,
        }));

        const worksheetWeekly = XLSX.utils.json_to_sheet(weeklyTotals);
        XLSX.utils.book_append_sheet(workbook, worksheetWeekly, "Riepilogo Settimanale");

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `Consegne_${selectedDate}.xlsx`);
    };

    // 🔹 Esporta in PDF
    const handleExportPDF = () => {
      if (!selectedOrders || selectedOrders.length === 0) {
        toast.warning("⚠️ Nessuna consegna da esportare");
        return;
      }

      {/*const doc = new jsPDF();*/}
      const doc = new jsPDF("landscape");
      doc.setFontSize(14);
      doc.text(`Consegne del ${selectedDate}`, 14, 15);

      const tableData = selectedOrders.map((o) => [
        o.rifOrdCli,
        o.tipoDoc,
        o.numDoc,
        o.ragioneSociale ? `${o.idCliente || ""} - ${o.ragioneSociale}` : "-",
        o.idDestinazione ? `${o.idDestinazione} - ${o.indirizzoDestinazione} - ${o.localitaDestinazione} (${o.provinciaDestinazione})` : "—",
        o.dataPrevCons1 ? isoToLocalDate(o.dataPrevCons1) : "-",
        getEffectivePC2Date(o) || "-",
        getVettoreExport(o),
        o.selData ? isoToLocalDate(o.selData) : "-",
        o.dataInvio ? isoToLocalDate(o.dataInvio) : "-",
        o.noteDoc,
        getListeEvasioneLabel(o),
        o.lotto || "-",
        o.statoProduzione || "-",
        getProductionWorkersLabel(o)
      ]);

      autoTable(doc, {
        head: [["Rif. Ordine", "Tipo Doc", "Num. Doc", "Cliente", "Destinazione", "Cons. 1", "Cons. 2", "Vettore", "Data Conf.", "Data Invio", "Annotazioni", "Lista evasione", "Lotto", "Stato Prod.", "Operai"]],
        body: tableData,
        startY: 25,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [60, 60, 60] },
      });

      doc.save(`Consegne_${selectedDate}.pdf`);
    };

    // 🔹 Esporta la settimana intera (Excel)
    const handleExportExcelWeek = () => {
      if (!selectedDate) {
        toast.warning("⚠️ Seleziona un giorno per determinare la settimana.");
        return;
      }

      const { start, end } = getWeekRange(new Date(selectedDate));

      // Filtra le consegne della settimana
      const weeklyOrders = visibleOrders.filter((o) => {
        const d1 = isoToLocalDate(o.dataPrevCons1);
        const d2 = getEffectivePC2Date(o) || "-";
        return (
          (d1 && d1 >= formatDate(start) && d1 <= formatDate(end)) ||
          (d2 && d2 >= formatDate(start) && d2 <= formatDate(end))
        );
      });

      if (weeklyOrders.length === 0) {
        toast.warning("⚠️ Nessuna consegna per questa settimana.");
        return;
      }

      // 🔹 Formatta range di date per il nome del foglio
      const rangeLabel = `${formatDate(start).replaceAll("-", ".")}_${formatDate(end).replaceAll("-", ".")}`;

      const worksheet = XLSX.utils.json_to_sheet(
        weeklyOrders.map((o) => ({
          "Rif. Ordine Cliente": o.rifOrdCli,
          "Tipo Documento": o.tipoDoc,
          "Numero Documento": o.numDoc,
          "Data Documento": o.dataDoc ? isoToLocalDate(o.dataDoc) : "-",
          "Cliente": o.ragioneSociale
            ? `${o.idCliente || ""} - ${o.ragioneSociale}`
            : "-",
          "Telefono Cliente": o.telefonoCliente || "-",
          "Email Cliente": o.emailCliente || "-",
          "Indirizzo": o.indirizzoCliente || "-",
          "Cap": o.capCliente || "-",
          "Località Cliente": o.localitaCliente || "-",
          "Provincia Cliente": o.provinciaCliente || "-",
          "Cliente Bloccato": o.blocco?.trim()?.toUpperCase() === "S" ? "SI" : "NO",
          "Destinazione": o.idDestinazione
            ? `${o.idDestinazione} - ${o.indirizzoDestinazione} - ${o.localitaDestinazione} (${o.provinciaDestinazione})`
            : "—",
          "Consegna 1": o.dataPrevCons1 ? isoToLocalDate(o.dataPrevCons1) : "-",
          "Consegna 2": getEffectivePC2Date(o) || "-",
          "Vettore": getVettoreExport(o),
          "Data Conferma Ordine": o.selData ? isoToLocalDate(o.selData) : "-",
          "Data Invio in Produzione": o.dataInvio ? isoToLocalDate(o.dataInvio) : "-",
          "Annotazioni": o.noteDoc || "-",
          "Lista evasione": getListeEvasioneLabel(o),
          "Lotto": o.lotto || "-",
          "Stato Produzione": o.statoProduzione || "-",
          "Operai Produzione": getProductionWorkersLabel(o)
        }))
      );

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, `Settimana_${rangeLabel}`);

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

      saveAs(blob, `Consegne_Week_${getWeekNumber(new Date(selectedDate))}.xlsx`);
    };

    // 🔹 Esporta la settimana intera (PDF)
    const handleExportPDFWeek = () => {
      if (!selectedDate) {
        toast.warning("⚠️ Seleziona un giorno per determinare la settimana.");
        return;
      }

      const { start, end } = getWeekRange(new Date(selectedDate));

      const weeklyOrders = visibleOrders.filter((o) => {
        const d1 = isoToLocalDate(o.dataPrevCons1);
        const d2 = getEffectivePC2Date(o) || "-";
        return (
          (d1 && d1 >= formatDate(start) && d1 <= formatDate(end)) ||
          (d2 && d2 >= formatDate(start) && d2 <= formatDate(end))
        );
      });

      if (weeklyOrders.length === 0) {
        toast.warning("⚠️ Nessuna consegna per questa settimana.");
        return;
      }

      const doc = new jsPDF("landscape");
      doc.setFontSize(14);
      doc.text(
        `Consegne settimana ${getWeekNumber(new Date(selectedDate))} (${formatDate(start)} / ${formatDate(end)})`,
        14,
        15
      );

      const tableData = weeklyOrders.map((o) => [
        o.rifOrdCli,
        o.tipoDoc,
        o.numDoc,
        o.ragioneSociale ? `${o.idCliente || ""} - ${o.ragioneSociale}` : "-",
        o.idDestinazione
          ? `${o.idDestinazione} - ${o.indirizzoDestinazione} - ${o.localitaDestinazione} (${o.provinciaDestinazione})`
          : "—",
        o.dataPrevCons1 ? isoToLocalDate(o.dataPrevCons1) : "-",
        getEffectivePC2Date(o) || "-",
        getVettoreExport(o),
        o.selData ? isoToLocalDate(o.selData) : "-",
        o.dataInvio ? isoToLocalDate(o.dataInvio) : "-",
        o.noteDoc || "-",
        getListeEvasioneLabel(o),
        o.lotto || "-",
        o.statoProduzione || "-",
        getProductionWorkersLabel(o)
      ]);

      autoTable(doc, {
        head: [
          [
            "Rif. Ordine",
            "Tipo Doc",
            "Num. Doc",
            "Cliente",
            "Destinazione",
            "Cons. 1",
            "Cons. 2",
            "Vettore",
            "Data Conf.",
            "Data Invio",
            "Annotazioni",
            "Lista evasione",
            "Lotto",
            "Stato Prod.",
            "Operai"
          ],
        ],
        body: tableData,
        startY: 25,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [60, 60, 60] },
      });

      doc.save(
        `Consegne_Week_${getWeekNumber(new Date(selectedDate))}_${formatDate(start)}.pdf`
      );
    };

    const getOrderDestinationLabel = (order) => {
      const localita = order.localitaDestinazione || order.localitaCliente;
      const provincia = order.provinciaDestinazione || order.provinciaCliente;

      if (localita && provincia) return `${localita} (${provincia})`;
      if (localita) return localita;
      if (order.indirizzoDestinazione) return order.indirizzoDestinazione;
      if (order.indirizzoCliente) return order.indirizzoCliente;
      return "Senza destinazione";
    };

    const getOrderOcLabel = (order) => {
      if (order.tipoDoc || order.numDoc) {
        return `${order.tipoDoc || "OC"} - ${order.numDoc || order.idDocumento || ""}`.trim();
      }

      return order.rifOrdCli || String(order.idDocumento || "-");
    };

    const getOrderVettoreOc = (order) => {
      if (order.descrizioneVettore) {
        return order.codiceVettore
          ? `${order.codiceVettore} - ${order.descrizioneVettore}`
          : order.descrizioneVettore;
      }

      return "-";
    };

    const getOrderDeliveryDatesForFilter = (order, filter) => {
      const d1 = isoToLocalDate(order.dataPrevCons1);
      const d2 = getEffectivePC2Date(order);

      if (filter === "PC1") return [d1].filter(Boolean);
      if (filter === "PC2") return [d2].filter(Boolean);
      if (filter === "BOTH") return Array.from(new Set([d1, d2].filter(Boolean)));

      return [];
    };

    const getPlanningWeeks = (date) => {
      const year = date.getFullYear();
      const month = date.getMonth();
      const firstDayOfMonth = new Date(year, month, 1);
      const lastDayOfMonth = new Date(year, month + 1, 0);
      const firstWeekStart = new Date(firstDayOfMonth);

      firstWeekStart.setDate(
        firstDayOfMonth.getDate() - ((firstDayOfMonth.getDay() + 6) % 7)
      );

      const weeks = [];
      let start = new Date(firstWeekStart);

      while (start <= lastDayOfMonth) {
        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        weeks.push({ start: new Date(start), end });
        start.setDate(start.getDate() + 7);
      }

      return weeks;
    };

    const handleExportMonthlyPlanning = () => {
      const year = activeMonth.getFullYear();
      const month = activeMonth.getMonth();
      const weeks = getPlanningWeeks(activeMonth);
      const planningStart = formatDate(weeks[0].start);
      const planningEnd = formatDate(weeks[weeks.length - 1].end);
      const planningOrders = visibleOrders.filter((order) =>
        getOrderDeliveryDatesForFilter(order, deliveryFilter)
          .some((date) => date >= planningStart && date <= planningEnd)
      );

      if (planningOrders.length === 0) {
        toast.warning("Nessun OC da esportare per il mese selezionato");
        return;
      }

      const destinations = new Map();
      const destinationOcLabels = new Map();
      const ocRows = [];
      const formatItDate = (date) => date.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
      });

      planningOrders.forEach((order) => {
        const destination = getOrderDestinationLabel(order);
        const ocLabel = getOrderOcLabel(order);

        if (!destinations.has(destination)) {
          destinations.set(destination, weeks.map(() => new Set()));
          destinationOcLabels.set(destination, new Set());
        }

        destinationOcLabels.get(destination).add(ocLabel);

        getOrderDeliveryDatesForFilter(order, deliveryFilter)
          .filter((date) => date >= planningStart && date <= planningEnd)
          .forEach((date) => {
            const index = weeks.findIndex((week) =>
              date >= formatDate(week.start) && date <= formatDate(week.end)
            );

            if (index >= 0) {
              destinations.get(destination)[index].add(order.idDocumento || ocLabel);
            }
          });

        ocRows.push({
          oc: ocLabel,
          destination,
          vettore: getOrderVettoreOc(order),
        });
      });

      const sortedDestinations = Array.from(destinations.keys()).sort((a, b) => a.localeCompare(b));
      const sortedOcRows = ocRows.sort((a, b) =>
        a.destination.localeCompare(b.destination) || a.oc.localeCompare(b.oc)
      );
      const rows = [
        ["Date", ...weeks.map((week) => `(${formatItDate(week.start)} - ${formatItDate(week.end)})`), "Liste OC"],
        ["Dest. del mese", ...weeks.map((week) => `Week ${getWeekNumber(week.start)}`), "Liste OC"],
      ];

      sortedDestinations.forEach((destination) => {
        rows.push([
          destination,
          ...destinations.get(destination).map((orders) => orders.size || ""),
          Array.from(destinationOcLabels.get(destination) || []).join(", "),
        ]);
      });

      rows.push([
        "Totale",
        ...weeks.map((_, index) =>
          sortedDestinations.reduce(
            (total, destination) => total + destinations.get(destination)[index].size,
            0
          ) || ""
        ),
        "",
      ]);

      rows.push([]);
      rows.push(["Export OC da caricare"]);
      rows.push(["OC", "Dest", "Vettore"]);
      sortedOcRows.forEach((row) => rows.push([row.oc, row.destination, row.vettore]));

      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      worksheet["!cols"] = [
        { wch: 28 },
        ...weeks.map(() => ({ wch: 18 })),
        { wch: 24 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Piano Consegne");

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `Piano_consegne_${year}_${String(month + 1).padStart(2, "0")}.xlsx`);
    };

    const getEvasoStatus = (isEvaso) => {
      if (isEvaso === 1) {
        return (
          <span className="text-sm font-medium text-green-600 flex items-center gap-1">
            ✅ Evaso
          </span>
        );
      }
      return (
        <span className="text-sm font-medium text-amber-600 flex items-center gap-1">
          ⏳ Da evadere
        </span>
      );
    };

    function getProductionWorkersLabel(order) {
      if (!order?.operaiProduzione || order.operaiProduzione.length === 0) {
        return "-";
      }

      return order.operaiProduzione.join(", ");
    }

    function getProductionStatusValue(order) {
      return (
        order?.stato ||
        order?.statoProduzione ||
        order?.status ||
        order?.statoAssegnazione ||
        order?.productionStatus ||
        ""
      );
    }

    const getProductionStatusColor = (status) => {
      switch (String(status || "").toUpperCase()) {
        case "PRODOTTO":
          return { backgroundColor: "#dcfce7", color: "#166534", borderColor: "#86efac" };
        case "CONFEZIONAMENTO":
          return { backgroundColor: "#fef9c3", color: "#854d0e", borderColor: "#fde68a" };
        case "CONSEGNA":
        case "PARTITO":
          return { backgroundColor: "#dbeafe", color: "#1d4ed8", borderColor: "#93c5fd" };
        default:
          return { backgroundColor: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
      }
    };

    const getProductionInfo = (order) => {
      const statusStyle = getProductionStatusColor(order.statoProduzione);

      return (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "0.5rem",
            marginTop: "0.35rem",
          }}
        >
          <span className="text-sm font-medium text-gray-700">
            Produzione:
          </span>
          <span className="text-sm text-gray-700">
            Lotto: {order.lotto || "-"}
          </span>
          {order.statoProduzione ? (
            <span
              style={{
                border: `1px solid ${statusStyle.borderColor}`,
                backgroundColor: statusStyle.backgroundColor,
                color: statusStyle.color,
                borderRadius: "999px",
                padding: "0.15rem 0.55rem",
                fontSize: "0.8rem",
                fontWeight: 600,
              }}
            >
              {order.statoProduzione}
            </span>
          ) : (
            <span className="text-sm text-gray-600">
              Stato: -
            </span>
          )}
          {getProductionWorkersLabel(order) !== "-" && (
            <span className="text-sm text-gray-600">
              Operai: {getProductionWorkersLabel(order)}
            </span>
          )}
        </div>
      );
    };

    const orderMatchesDate = (order, dayStr, filter) => {
      const d1 = isoToLocalDate(order.dataPrevCons1);
      const d2 = getEffectivePC2Date(order);

      switch (filter) {
        case "PC1":
          return dayStr === d1;
        case "PC2":
          return dayStr === d2;
        case "BOTH":
          return dayStr === d1 || dayStr === d2;
        default:
          return false;
      }
    };

    function getFilteredEvents(orders, filter) {
      const map = {};

      orders.forEach((o) => {
        const d1 = isoToLocalDate(o.dataPrevCons1);
        const d2 = getEffectivePC2Date(o);

        let dates = [];

        if (filter === "PC1" && d1) dates = [d1];
        if (filter === "PC2" && d2) dates = [d2];
        if (filter === "BOTH") {
              dates = Array.from(
                new Set([d1, d2].filter(Boolean))
              );
            }

        dates.forEach((d) => {
          map[d] = (map[d] || 0) + 1;
        });
      });

      return map;
    }

    const filteredEvents = useMemo(
      () => getFilteredEvents(visibleOrders, deliveryFilter),
      [visibleOrders, deliveryFilter]
    );

    function filterOrdersByDateAndType(orders, dayStr, filter) {
      return orders.filter((o) => {
        const d1 = isoToLocalDate(o.dataPrevCons1);
        const d2 = getEffectivePC2Date(o);

        switch (filter) {
          case "PC1":
            return d1 === dayStr;
          case "PC2":
            return d2 === dayStr;
          case "BOTH":
            return d1 === dayStr || d2 === dayStr;
          default:
          return false;
        }
      });
    }

    const getListeEvasioneLabel = (order) => {
      if (!order?.listeEvasione || order.listeEvasione.length === 0) {
        return "—";
      }

      return order.listeEvasione
        .map(l => `${l.tipoDoc}-${l.numDoc}`)
        .join(", ");
    };

    const openEditDataPrevCons1 = (order) => {
      setEditOrder(order);
      setEditDate(isoToLocalDate(order.dataPrevCons1) || selectedDate || formatDate(new Date()));
    };

    const closeEditDataPrevCons1 = () => {
      if (updatingDeliveryId) return;
      setEditOrder(null);
      setEditDate(null);
    };

    const getErrorMessage = (err, fallback = "Impossibile aggiornare la data prevista consegna 1") => {
      const data = err?.response?.data;
      if (typeof data === "string" && data.trim()) return data;
      if (data?.message) return data.message;
      return fallback;
    };

    const handleConfirmDataPrevCons1 = async () => {
      if (!editOrder?.idDocumento || !editDate) {
        toast.warning("Dati ordine non disponibili");
        return;
      }

      const currentDate = isoToLocalDate(editOrder.dataPrevCons1);
      if (currentDate === editDate) {
        toast.info("La data selezionata e' gia' impostata sull'ordine");
        closeEditDataPrevCons1();
        return;
      }

      setUpdatingDeliveryId(editOrder.idDocumento);
      try {
        await backendApi.put(
          `/api/consegne/${editOrder.idDocumento}/data-prev-cons1`,
          { dataPrevCons1: editDate }
        );

        const nextActiveMonth = new Date(`${editDate}T00:00:00`);
        setSelectedDate(editDate);
        setActiveMonth(nextActiveMonth);
        await refreshConsegneForDate(nextActiveMonth);
        toast.success("Data prevista consegna 1 aggiornata");
        setEditOrder(null);
        setEditDate(null);
      } catch (err) {
        if (err?.response?.status === 409) {
          toast.warning(getErrorMessage(err));
        } else {
          toast.error(getErrorMessage(err));
        }
      } finally {
        setUpdatingDeliveryId(null);
      }
    };

    const fetchVettori = async () => {
      if (vettori.length > 0 || loadingVettori) return;

      setLoadingVettori(true);
      try {
        const res = await backendApi.get("/api/consegne/vettori");
        setVettori(res.data || []);
      } catch (err) {
        console.error("Errore fetch vettori:", err);
        toast.error("Impossibile recuperare la lista dei vettori");
      } finally {
        setLoadingVettori(false);
      }
    };

    const openEditVettore = (order) => {
      if (order?.listeEvasione?.length > 0) {
        toast.info("Ordine evaso in lista: il vettore della card OC non e' modificabile qui");
        return;
      }

      setEditVettoreOrder(order);
      setSelectedVettoreCode(order.codiceVettore || "");
      fetchVettori();
    };

    const closeEditVettore = () => {
      if (updatingVettoreId) return;
      setEditVettoreOrder(null);
      setSelectedVettoreCode("");
    };

    const getVettoreLabel = (vettore) => {
      if (!vettore) return "";
      return vettore.descrizione
        ? `${vettore.codice} - ${vettore.descrizione}`
        : vettore.codice;
    };

    const handleConfirmVettore = async () => {
      if (!editVettoreOrder?.idDocumento || !selectedVettoreCode) {
        toast.warning("Seleziona un vettore");
        return;
      }

      if (editVettoreOrder.codiceVettore === selectedVettoreCode) {
        toast.info("Il vettore selezionato e' gia' impostato sull'ordine");
        closeEditVettore();
        return;
      }

      setUpdatingVettoreId(editVettoreOrder.idDocumento);
      try {
        await backendApi.put(
          `/api/consegne/${editVettoreOrder.idDocumento}/vettore`,
          { codiceVettore: selectedVettoreCode }
        );

        await refreshConsegneForDate(activeMonth);
        toast.success("Vettore aggiornato");
        setEditVettoreOrder(null);
        setSelectedVettoreCode("");
      } catch (err) {
        toast.error(getErrorMessage(err, "Impossibile aggiornare il vettore"));
      } finally {
        setUpdatingVettoreId(null);
      }
    };



  return (
    <>
      <Container maxWidth={false}>
        <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', marginTop: '2rem', gap: '5rem' }}>

          {/* Calendario + Legenda */}
          <div className="flex-1 min-w-0">

            {/* 🔹 Filtro consegne */}
            <ToggleButtonGroup
              value={deliveryFilter}
              exclusive
              onChange={(_, value) => {
                if (value) setDeliveryFilter(value);
              }}
              size="small"
              sx={{
                mb: 2,
                backgroundColor: "#f9fafb",
                borderRadius: "12px",
                "& .MuiToggleButton-root": {
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "1rem",
                  border: "none",
                  px: 2,
                },
                "& .Mui-selected": {
                  backgroundColor: "#4f46e5 !important",
                  color: "#ffffff !important",
                  boxShadow: "0 4px 10px rgba(79,70,229,0.25)",
                },
              }}
            >
              <ToggleButton value="PC1">
                Prev. Cons. 1
              </ToggleButton>

              <ToggleButton value="PC2">
                Prev. Cons. 2
              </ToggleButton>

              <ToggleButton value="BOTH">
                Entrambe
              </ToggleButton>
            </ToggleButtonGroup>

            <div
              style={{
                marginBottom: "1rem",
                padding: "0.75rem",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                backgroundColor: "#ffffff",
                boxShadow: "0 1px 3px rgba(15, 23, 42, 0.08)",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr)) auto",
                  gap: "0.75rem",
                  alignItems: "end",
                }}
              >
                <label style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}>
                  <span className="text-sm font-medium text-gray-700">Cliente</span>
                  <input
                    type="search"
                    list="consegne-clienti"
                    value={customerFilter}
                    onChange={(event) => setCustomerFilter(event.target.value)}
                    placeholder="Cerca codice o ragione sociale"
                    aria-label="Filtra per cliente"
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      padding: "0.6rem 0.75rem",
                      fontSize: "0.95rem",
                      outlineColor: "#4f46e5",
                    }}
                  />
                  <datalist id="consegne-clienti">
                    {customerOptions.map((customer) => (
                      <option key={customer} value={customer} />
                    ))}
                  </datalist>
                </label>

                <label style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}>
                  <span className="text-sm font-medium text-gray-700">Lotto</span>
                  <input
                    type="search"
                    list="consegne-lotti"
                    value={lotFilter}
                    onChange={(event) => setLotFilter(event.target.value)}
                    placeholder="Cerca lotto"
                    aria-label="Filtra per lotto"
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      padding: "0.6rem 0.75rem",
                      fontSize: "0.95rem",
                      outlineColor: "#4f46e5",
                    }}
                  />
                  <datalist id="consegne-lotti">
                    {lotOptions.map((lotto) => (
                      <option key={lotto} value={lotto} />
                    ))}
                  </datalist>
                </label>

                {hasDataFilters && (
                  <button
                    type="button"
                    onClick={clearDataFilters}
                    style={{
                      border: "1px solid #d1d5db",
                      backgroundColor: "#f9fafb",
                      color: "#374151",
                      borderRadius: "8px",
                      padding: "0.6rem 0.75rem",
                      cursor: "pointer",
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Pulisci
                  </button>
                )}
              </div>
            </div>


            <Card className="rounded-2xl shadow-lg border border-gray-200">
              <CardContent className="p-6 relative flex flex-col lg:flex-row gap-6">

                {loading && (
                  <div className="absolute inset-0 flex items-center justify-center bg-white/70 backdrop-blur-sm rounded-xl z-10">
                    <motion.div
                      className="w-10 h-10 border-4 border-indigo-400 border-t-transparent rounded-full animate-spin"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ repeat: Infinity, duration: 1.2 }}
                    />
                  </div>
                )}

                <div className="flex-1">
                  <Calendar
                    className="rounded-xl overflow-hidden"
                    value={selectedDate ? new Date(selectedDate) : new Date()}
                    tileContent={tileContent}
                    onActiveStartDateChange={({ activeStartDate }) =>
                        setActiveMonth(activeStartDate)
                      }
                    onClickDay={handleDayClick}
                  />
                </div>

                {/* Legenda */}
                <div style={{ width: '30rem', flexShrink: 0, fontSize: '0.875rem', color: '#4B5563', marginTop: '2rem' }}>
                  <h4 className="font-semibold mb-2 text-gray-700">Legenda badge</h4>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <Badge color="#60a5fa">●</Badge><span>Meno di 5 consegne</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <Badge color="#fbbf24">●</Badge><span>5-9 consegne</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <Badge color="#ef4444">●</Badge><span>10 o più consegne</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* 🔹 Linea verticale */}
          <div style={{ width: '1px', background: 'linear-gradient(to bottom, #e5e7eb, #d1d5db)', height: 'auto', alignSelf: 'stretch', opacity: 0.8 }} />

          {/* Dettagli giorno + riepilogo settimana */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 flex-1">

                   <div style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "0.5rem",
                        flexWrap: "wrap",
                        marginBottom: "1rem"
                      }}>
                        <button
                          onClick={handleExportExcel}
                          style={{
                            backgroundColor: "black",  // sfondo nero
                            color: "white",             // testo bianco
                            padding: "0.5rem 1rem",
                            borderRadius: "8px",
                            border: "none",
                            cursor: "pointer",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          📄 Esporta Giorno (Excel)
                        </button>
                        <button
                          onClick={handleExportPDF}
                          style={{
                            backgroundColor: "black",  // sfondo nero
                            color: "white",             // testo bianco
                            padding: "0.5rem 1rem",
                            borderRadius: "8px",
                            border: "none",
                            cursor: "pointer",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          📄 Scarica Giorno (PDF)
                        </button>
                        <button
                          onClick={handleExportExcelWeek}
                          style={{
                            backgroundColor: "gray",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "8px",
                            border: "none",
                            cursor: "pointer",
                            fontWeight: "500",
                          }}
                        >
                          📄 Esporta Settimana (Excel)
                        </button>

                        <button
                          onClick={handleExportPDFWeek}
                          style={{
                            backgroundColor: "gray",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "8px",
                            border: "none",
                            cursor: "pointer",
                            fontWeight: "500",
                          }}
                        >
                          📄 Scarica Settimana (PDF)
                        </button>
                        <button
                          onClick={handleExportMonthlyPlanning}
                          style={{
                            backgroundColor: "#2563eb",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "8px",
                            border: "none",
                            cursor: "pointer",
                            fontWeight: "500",
                          }}
                        >
                          Esporta Mese OC/Vettori
                        </button>
                      </div>

            {selectedDate ? (
              <>
                {/* Riepilogo settimana */}
                <Card className="rounded-2xl shadow-lg border border-gray-200">
                    <CardContent className="p-6 relative flex flex-col lg:flex-row gap-6">
                        <div
                          style={{
                            marginBottom: '1rem',        // mb-4
                            padding: '1rem',             // p-4
                            borderRadius: '0.5rem',      // rounded-lg
                            backgroundColor: '#e5e7eb',  // bg-gray-200
                            border: '1px solid #e5e7eb', // border-gray-200
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)', // opzionale, simile a shadow-sm
                          }}
                        >
                          <h4 className="font-semibold text-gray-700 mb-2">📅 Riepilogo settimanale</h4>

                          {getMonthWeeklyTotals(filteredEvents, new Date(selectedDate)).map((week, idx) => (
                            <p key={idx} className="text-sm text-gray-700">
                              Week {getWeekNumber(week.start)} ({formatDate(week.start)} → {formatDate(week.end)}): <b>{week.total}</b> consegne
                            </p>
                          ))}
                        </div>
                    </CardContent>
                </Card>

                {/* Dettaglio giorno */}
                <div style={{marginTop: '2rem'}}>
                    <h3 className="text-xl font-bold mb-4 text-indigo-600 flex items-center gap-2">
                      📦 <b>Consegne del {selectedDate}</b>
                    </h3>
                </div>

                <AnimatePresence mode="wait">
                  <motion.div
                    key={selectedDate}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                    className="space-y-4 max-h-[65vh] overflow-y-auto pr-2"
                  >
                    <p className="text-gray-700 mb-3">{selectedOrders.length} consegne trovate</p>

                    {selectedOrders.length === 0 ? (
                      <p className="text-gray-500 italic">Nessuna consegna prevista per questa data.</p>
                    ) : (
                      selectedOrders.map((order) => (
                        <Card key={order.idDocumento} className="rounded-xl border border-gray-200 hover:shadow-md transition-all" >
                            <CardContent className="p-4 space-y-2">
                              <div className="flex justify-between items-start">
                                <div>
                                  <div className="flex items-center gap-2">
                                    <h3 className="font-semibold text-gray-800">{order.rifOrdCli}</h3>

                                    {order.blocco?.trim()?.toUpperCase() === "S" && (
                                      <div className="flex items-center gap-1">
                                        <span style={{ color: '#b91c1c', fontWeight: 'bold' }}>
                                          🔴 CLIENTE BLOCCATO
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  {getEvasoStatus(order.isEvaso)}
                                  {getProductionInfo(order)}
                                  {/* 📄 Liste di evasione */}
                                  {order.listeEvasione && order.listeEvasione.length > 0 && (
                                    <div className="mt-2">
                                      <p className="text-sm font-medium text-gray-700 mb-1">
                                        📄 Liste di evasione:
                                      </p>

                                      <div className="overflow-x-auto">
                                        <table className="min-w-full text-sm text-gray-600 border border-gray-200 rounded-lg">
                                          <thead className="bg-gray-100 text-gray-700">
                                            <tr>
                                              <th className="px-2 py-1 text-left">Tipo Doc</th>
                                              <th className="px-2 py-1 text-left">Num Doc</th>
                                              <th className="px-2 py-1 text-left">Data</th>
                                              <th className="px-2 py-1 text-left">Vettore</th>
                                              <th className="px-2 py-1 text-left">Inizio Trasp.</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {order.listeEvasione.map((l, idx) => (
                                              <tr key={idx} className="border-t border-gray-200">
                                                <td className="px-2 py-1">{l.tipoDoc}</td>
                                                <td className="px-2 py-1">{l.numDoc}</td>
                                                <td className="px-2 py-1">
                                                  {l.dataDoc
                                                    ? new Date(l.dataDoc).toLocaleDateString("it-IT", {
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric",
                                                      })
                                                    : "—"}
                                                </td>
                                                <td className="px-2 py-1">{l.vettore || "-"}</td>
                                                <td className="px-2 py-1">
                                                  {formatTrasporto(l.inizioTrasporto)}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <Badge color="#2563eb" textColor="#ffffff">
                                  {order.tipoDoc}
                                </Badge>
                              </div>


                              <p className="text-sm text-gray-500">Ordine n° {order.numDoc} del{" "}
                                                                                              {order.dataDoc
                                                                                                ? new Date(order.dataDoc).toLocaleDateString("it-IT", {
                                                                                                    day: "2-digit",
                                                                                                    month: "2-digit",
                                                                                                    year: "numeric",
                                                                                                  })
                                                                                                : "—"}</p>
                              <p className="text-sm text-gray-700">
                                <b>Cliente:</b>{" "}
                                {order.idCliente
                                  ? `${order.idCliente} - ${order.ragioneSociale ?? "N/A"}`
                                  : "—"}
                              </p>
                              <p className="text-sm text-gray-700">
                                <b>Destinazione:</b>{" "}
                                {order.idDestinazione
                                  ? `${order.idDestinazione} - ${order.indirizzoDestinazione} - ${order.localitaDestinazione} (${order.provinciaDestinazione})`
                                  : "—"}
                              </p>
                              <p className="text-sm text-gray-600" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                <b>Consegna 1:</b>{" "}
                                {order.dataPrevCons1
                                  ? isoToLocalDate(order.dataPrevCons1)
                                  : "—"}
                                <button
                                  type="button"
                                  onClick={() => openEditDataPrevCons1(order)}
                                  title="Modifica prevista consegna 1"
                                  aria-label="Modifica prevista consegna 1"
                                  disabled={updatingDeliveryId === order.idDocumento}
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "999px",
                                    border: "1px solid #c7d2fe",
                                    backgroundColor: "#eef2ff",
                                    color: "#4f46e5",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: updatingDeliveryId === order.idDocumento ? "not-allowed" : "pointer",
                                    opacity: updatingDeliveryId === order.idDocumento ? 0.6 : 1,
                                  }}
                                >
                                  <Pencil size={15} strokeWidth={2} />
                                </button>
                              </p>
                              <p className="text-sm text-gray-600">
                                <b>Consegna 2:</b>{" "}
                                {getEffectivePC2Date(order) || "—"}
                              </p>
                              <p className="text-sm text-gray-700" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                <b>Vettore:</b>{" "}
                                {order.descrizioneVettore
                                  ? `${order.codiceVettore || ""} - ${order.descrizioneVettore}`
                                  : "-"}
                                <button
                                  type="button"
                                  onClick={() => openEditVettore(order)}
                                  title="Modifica vettore"
                                  aria-label="Modifica vettore"
                                  disabled={updatingVettoreId === order.idDocumento || order?.listeEvasione?.length > 0}
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "999px",
                                    border: "1px solid #c7d2fe",
                                    backgroundColor: "#eef2ff",
                                    color: "#4f46e5",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: updatingVettoreId === order.idDocumento || order?.listeEvasione?.length > 0 ? "not-allowed" : "pointer",
                                    opacity: updatingVettoreId === order.idDocumento || order?.listeEvasione?.length > 0 ? 0.6 : 1,
                                  }}
                                >
                                  <Pencil size={15} strokeWidth={2} />
                                </button>
                              </p>
                              <p className="text-sm text-gray-600">
                                <b>Data Conferma Ordine:</b>{" "}
                                {order.selData
                                  ? isoToLocalDate(order.selData)
                                  : "—"}
                              </p>
                              <p className="text-sm text-gray-600">
                                <b>Inviato in prod il:</b>{" "}
                                {order.dataInvio
                                  ? isoToLocalDate(order.dataInvio)
                                  : "—"}
                              </p>
                              {order.tForIdDoc != null && (
                                <div
                                  style={{
                                    border: "1px solid #93c5fd",
                                    borderRadius: "8px",
                                    backgroundColor: "#f0f9ff",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                    padding: "10px 12px",
                                    marginTop: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: "8px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <b style={{ fontSize: "0.9rem", color: "#075985" }}>
                                      Ordine fornitore (OF)
                                    </b>
                                    <span
                                      style={{
                                        borderRadius: "999px",
                                        padding: "2px 8px",
                                        fontSize: "0.78rem",
                                        fontWeight: 600,
                                        backgroundColor: order.tForIsEvaso === 1 ? "#dcfce7" : "#fef3c7",
                                        color: order.tForIsEvaso === 1 ? "#166534" : "#92400e",
                                      }}
                                    >
                                      {order.tForIsEvaso === 1 ? "Evaso" : "Da evadere"}
                                    </span>
                                  </div>
                                  <div style={{ fontSize: "0.88rem", color: "#374151", lineHeight: 1.5 }}>
                                    <div><b>ID documento:</b> {order.tForIdDoc}</div>
                                    <div>
                                      <b>Consegna prevista:</b>{" "}
                                      {order.tForPrevCons ? isoToLocalDate(order.tForPrevCons) : "—"}
                                    </div>
                                  </div>
                                </div>
                              )}
                              <p className="text-sm text-gray-600">
                                <b>Annotazioni:</b>
                                {order.noteDoc ? (
                                  <div
                                    style={{
                                      border: "1px solid #d1d5db",
                                      borderRadius: "8px",
                                      backgroundColor: "#ffffff",
                                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                      padding: "12px",
                                    }}
                                  >
                                    <p
                                      style={{
                                        fontSize: "0.9rem",
                                        color: "#1f2937",
                                        whiteSpace: "pre-line",
                                      }}
                                    >
                                      {order.noteDoc}
                                    </p>
                                  </div>

                              ) : (
                                <p className="text-sm text-gray-600">
                                  <b>Annotazioni: {"-"}</b>
                                </p>
                              )}
                              </p>
                            </CardContent>
                          </Card>
                      ))
                    )}
                  </motion.div>
                </AnimatePresence>
              </>
            ) : (
              <motion.p key="no-selection" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="text-gray-500">
                Seleziona un giorno sul calendario per vedere i dettagli.
              </motion.p>
            )}
          </div>
        </div>
      </Container>

      {editOrder && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(15, 23, 42, 0.45)",
            padding: "1rem",
          }}
        >
          <div
            style={{
              width: "min(420px, 100%)",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 20px 45px rgba(15, 23, 42, 0.25)",
              padding: "1.25rem",
            }}
          >
            <div style={{ marginBottom: "1rem" }}>
              <h3 className="text-lg font-semibold text-gray-800">
                Modifica prevista consegna 1
              </h3>
              <p className="text-sm text-gray-600">
                Ordine {editOrder.tipoDoc} {editOrder.numDoc} - {editOrder.rifOrdCli || "senza riferimento"}
              </p>
            </div>

            <Calendar
              className="rounded-xl overflow-hidden"
              value={editDate ? new Date(`${editDate}T00:00:00`) : new Date()}
              onClickDay={(value) => setEditDate(formatDate(value))}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "0.75rem",
                marginTop: "1rem",
              }}
            >
              <span className="text-sm text-gray-700">
                Nuova data: <b>{editDate || "-"}</b>
              </span>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <button
                  type="button"
                  onClick={closeEditDataPrevCons1}
                  disabled={!!updatingDeliveryId}
                  style={{
                    padding: "0.5rem 0.85rem",
                    borderRadius: "8px",
                    border: "1px solid #d1d5db",
                    backgroundColor: "#ffffff",
                    color: "#374151",
                    cursor: updatingDeliveryId ? "not-allowed" : "pointer",
                  }}
                >
                  Annulla
                </button>
                <button
                  type="button"
                  onClick={handleConfirmDataPrevCons1}
                  disabled={!editDate || !!updatingDeliveryId}
                  style={{
                    padding: "0.5rem 0.85rem",
                    borderRadius: "8px",
                    border: "none",
                    backgroundColor: "#4f46e5",
                    color: "#ffffff",
                    fontWeight: 600,
                    cursor: !editDate || updatingDeliveryId ? "not-allowed" : "pointer",
                    opacity: !editDate || updatingDeliveryId ? 0.65 : 1,
                  }}
                >
                  {updatingDeliveryId ? "Salvataggio..." : "Conferma"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editVettoreOrder && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(15, 23, 42, 0.45)",
            padding: "1rem",
          }}
        >
          <div
            style={{
              width: "min(520px, 100%)",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 20px 45px rgba(15, 23, 42, 0.25)",
              padding: "1.25rem",
            }}
          >
            <div style={{ marginBottom: "1rem" }}>
              <h3 className="text-lg font-semibold text-gray-800">
                Modifica vettore
              </h3>
              <p className="text-sm text-gray-600">
                Ordine {editVettoreOrder.tipoDoc} {editVettoreOrder.numDoc} - {editVettoreOrder.rifOrdCli || "senza riferimento"}
              </p>
            </div>

            {loadingVettori ? (
              <p className="text-sm text-gray-600">Caricamento vettori...</p>
            ) : (
              <select
                value={selectedVettoreCode}
                onChange={(event) => setSelectedVettoreCode(event.target.value)}
                style={{
                  width: "100%",
                  padding: "0.65rem 0.75rem",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  color: "#1f2937",
                  backgroundColor: "#ffffff",
                }}
              >
                <option value="">Seleziona vettore</option>
                {vettori.map((vettore) => (
                  <option key={vettore.codice} value={vettore.codice}>
                    {getVettoreLabel(vettore)}
                  </option>
                ))}
              </select>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "0.5rem",
                marginTop: "1rem",
              }}
            >
              <button
                type="button"
                onClick={closeEditVettore}
                disabled={!!updatingVettoreId}
                style={{
                  padding: "0.5rem 0.85rem",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                  backgroundColor: "#ffffff",
                  color: "#374151",
                  cursor: updatingVettoreId ? "not-allowed" : "pointer",
                }}
              >
                Annulla
              </button>
              <button
                type="button"
                onClick={handleConfirmVettore}
                disabled={!selectedVettoreCode || !!updatingVettoreId}
                style={{
                  padding: "0.5rem 0.85rem",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "#4f46e5",
                  color: "#ffffff",
                  fontWeight: 600,
                  cursor: !selectedVettoreCode || updatingVettoreId ? "not-allowed" : "pointer",
                  opacity: !selectedVettoreCode || updatingVettoreId ? 0.65 : 1,
                }}
              >
                {updatingVettoreId ? "Salvataggio..." : "Conferma"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

